import LoaderLocal from "./LoaderLocal";

export default LoaderLocal;
